import { Linkedin } from "lucide-react";

const services = [
  { name: "Field Tablets & Mobile Internet", path: "/field-tablets-mobile-internet" },
  { name: "Fleet & Asset Tracking", path: "/fleet-asset-tracking" },
  { name: "Jobsite Connectivity", path: "/jobsite-connectivity" },
  { name: "Push-to-Talk", path: "/push-to-talk" },
  { name: "Business Internet", path: "/business-internet-solutions" },
  { name: "Failover Internet", path: "/failover-solutions" },
  { name: "Fixed Wireless Internet", path: "/fixed-wireless-solutions" },
  { name: "IoT Connectivity", path: "/internet-of-things-iot" },
  { name: "POTS Line Replacement", path: "/pots-replacement-solutions" },
  { name: "Starlink Business", path: "/starlink-business-internet" },
  { name: "Home Internet", path: "/home-internet" },
];

const company = [
  { name: "About", path: "/about-us" },
  { name: "Contact", path: "/contact-us" },
  { name: "Become a Partner", path: "/become-a-partner" },
];

export const Footer = () => {
  return (
    <footer className="glass-card border-t mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Services Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">Services</h3>
            <ul className="space-y-2">
              {services.map((item) => (
                <li key={item.name}>
                  <a href={item.path} className="nav-link text-sm">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">Company</h3>
            <ul className="space-y-2">
              {company.map((item) => (
                <li key={item.name}>
                  <a href={item.path} className="nav-link text-sm">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">Contact</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>
                <span className="font-medium">Phone:</span>{" "}
                <a href="tel:+15128595047" className="nav-link hover:text-primary transition-colors">
                  (512) 859-5047
                </a>
              </p>
              <p className="text-xs mt-3">Serving Businesses Nationwide | Global Connectivity</p>
            </div>
          </div>

          {/* Support Column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-4">Support</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p className="font-semibold text-white">Business: NOC Center 24/7</p>
              <p>Residential: M-F 9-6 CST</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <a href="/terms-of-service" className="nav-link">Terms of Service</a>
            <span>•</span>
            <a href="/privacy-policy" className="nav-link">Privacy Policy</a>
          </div>

          <div className="flex items-center gap-4">
            <a 
              href="#" 
              className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-5 w-5 text-primary" />
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} SimNet Wireless. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
